import { NanoID, NanoIdFilterType } from '../../../../../types';

export const enum UniversalFilterCompanyNanoIdModes {
  CONTAINS_ANY_OF = 'contains_any_of'
}

export type UniversalFilterCompanyNanoIdValue = NanoIdFilterType;

export type UniversalFilterCompanyNanoIdFilterState = {
  mode: UniversalFilterCompanyNanoIdModes;
  companyNanoIds?: NanoID[];
};

export type UniversalFilterCompanyNanoIdOnFilterStateChange = (
  state: UniversalFilterCompanyNanoIdFilterState
) => void;

export type UniversalFilterCompanyNanoIdOnChange = (
  value?: UniversalFilterCompanyNanoIdValue
) => void;
